import React from "react";
import { Link } from "react-router-dom";
import Layout from "../layout/Layout";

// Programme Kiddoes - 4 à 6 ans
export const ProgrammeKiddoesPage = () => (
  <Layout>
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#FF6B9D] to-[#C44569] py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'}} />
        </div>
        <div className="max-w-7xl mx-auto px-4 text-center relative z-10">
          <span className="inline-block px-4 py-2 bg-white/20 rounded-full text-white text-sm font-medium mb-4">
            🌟 Éveil à l&apos;anglais
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Kiddoes</h1>
          <p className="text-xl text-pink-100 max-w-2xl mx-auto">
            Nous voulons que la première expérience de votre enfant avec l&apos;anglais soit épanouissante
          </p>
          <p className="text-2xl font-semibold text-white mt-4">4 à 6 ans</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-[#FFF5F8]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-[#2C3C65] mb-6">Spécial 4 à 6 ans</h2>
              <p className="text-lg text-[#6777A1] mb-6">
                Avec nos programmes spécialement conçus pour les enfants de 4 à 6 ans, votre enfant développera 
                une attitude positive envers l&apos;apprentissage qui lui sera utile tout au long de sa vie.
              </p>
              <p className="text-lg text-[#6777A1] mb-6">
                Apprendre des chansons, des poèmes américains et britanniques et des vidéos animées de comptines 
                font partie de notre programme Kiddoes.
              </p>
              <p className="text-lg text-[#6777A1]">
                Il combine notre expertise en enseignement de l&apos;anglais avec des personnages animés de renommée mondiale. 
                Ensemble, ils offrent à votre enfant une expérience heureuse et mémorable de l&apos;apprentissage de la langue.
              </p>
            </div>
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=600"
                alt="Enfants apprenant"
                className="rounded-2xl shadow-xl"
              />
              <div className="absolute -bottom-4 -right-4 bg-[#FF6B9D] text-white p-4 rounded-xl shadow-lg">
                <span className="text-3xl font-bold">4-6</span>
                <span className="text-sm block">ans</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pourquoi apprendre des comptines */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Pourquoi apprendre des comptines ?</h2>
          <p className="text-center text-[#6777A1] mb-12 max-w-3xl mx-auto">
            The English Speaking Center a organisé des ressources pour que les parents s&apos;engagent 
            et soutiennent leurs enfants à la maison.
          </p>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-[#FF6B9D] rounded-full flex items-center justify-center mb-6">
                <span className="text-3xl">💡</span>
              </div>
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">Apprentissage éclairé</h3>
              <p className="text-[#6777A1]">
                Notre approche de l&apos;apprentissage est d&apos;éveiller la créativité, sa pensée critique 
                afin de développer des compétences de compréhension. Il promeut une philosophie basée 
                sur la valorisation de soi, des autres et de l&apos;environnement.
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-[#285BBB] rounded-full flex items-center justify-center mb-6">
                <span className="text-3xl">👩‍🏫</span>
              </div>
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">Enseignante dévouée</h3>
              <p className="text-[#6777A1]">
                Une enseignante dévouée, spécialement formée, expérimentée et passionnée, 
                formée à des méthodologies pédagogiques innovantes, dispense des cours dans 
                un environnement sûr et propice.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ce que votre enfant apprendra */}
      <section className="py-16 bg-[#FFF5F8]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Avec ce programme, votre enfant...</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { emoji: "🎯", text: "Acquerra un intérêt pour la langue anglaise" },
              { emoji: "✍️", text: "Apprendra à écrire grâce à une méthodologie unique en utilisant la narration" },
              { emoji: "😊", text: "S'amusera et développera une attitude positive face à l'apprentissage" },
              { emoji: "🗣️", text: "Découvrira les bases d'une excellente prononciation grâce à notre programme Phonétique" },
              { emoji: "🤗", text: "Se sentira en sécurité et pleinement soutenu par nos enseignants tout au long du processus" },
              { emoji: "🧠", text: "Gagnera en agilité mentale grâce à des activités multi-sensorielles et manuelles" },
            ].map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <span className="text-4xl mb-4 block">{item.emoji}</span>
                <p className="text-[#2C3C65] font-medium">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-[#FF6B9D] to-[#C44569]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Offrez à votre enfant le meilleur départ</h2>
          <p className="text-xl text-pink-100 mb-8">
            Les places sont limitées pour garantir un suivi personnalisé de chaque enfant.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/inscription"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#C44569] font-semibold rounded-xl hover:bg-pink-50 transition-colors"
            >
              Inscrire mon enfant
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-semibold rounded-xl hover:bg-white/10 transition-colors"
            >
              Nous contacter
            </Link>
          </div>
        </div>
      </section>
    </div>
  </Layout>
);

// Programme Pages
export const ProgrammesEnfantsPage = () => (
  <Layout>
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#285BBB] to-[#2C3C65] py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'}} />
        </div>
        <div className="max-w-7xl mx-auto px-4 text-center relative z-10">
          <span className="inline-block px-4 py-2 bg-white/20 rounded-full text-white text-sm font-medium mb-4">
            Cambridge Young Learners
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Programmes Enfants</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Un apprentissage ludique et efficace pour les enfants de 6 à 12 ans avec les examens Cambridge Starters, Movers et Flyers
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-[#F5F7FF]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-[#2C3C65] mb-6">Pourquoi commencer jeune ?</h2>
              <p className="text-lg text-[#6777A1] mb-6">
                Les enfants ont une capacité naturelle à absorber les langues. En commençant l&apos;apprentissage de l&apos;anglais dès le plus jeune âge, 
                ils développent une prononciation native et une aisance naturelle dans la communication.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#285BBB] rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#2C3C65]">Méthode Cambridge</h4>
                    <p className="text-sm text-[#6777A1]">Apprentissage basé sur le jeu et l&apos;interaction</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#285BBB] rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#2C3C65]">Formateurs natifs</h4>
                    <p className="text-sm text-[#6777A1]">Enseignants de langue maternelle anglaise</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#285BBB] rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#2C3C65]">Certifications reconnues</h4>
                    <p className="text-sm text-[#6777A1]">Diplômes Cambridge valables à vie</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_7ad81f0f-836b-4ad1-b763-41e7e6b8cfe2/artifacts/8l5pl8n1_2025-06-18.webp"
                alt="Élèves avec diplômes"
                className="rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Programmes détaillés */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Nos programmes par niveau</h2>
          
          <div className="space-y-8">
            {/* Starters */}
            <div className="bg-gradient-to-r from-green-50 to-green-100 p-8 rounded-2xl border-l-4 border-green-500">
              <div className="grid md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 bg-green-500 text-white text-sm font-semibold rounded-full">Pre-A1</span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Cambridge Starters</h3>
                  <p className="text-[#6777A1] mb-4">
                    Premier pas dans l&apos;apprentissage de l&apos;anglais. Les enfants découvrent la langue à travers des activités ludiques : 
                    chansons, jeux de rôle, dessins et histoires. L&apos;objectif est de créer une base solide et de développer 
                    l&apos;amour de la langue anglaise.
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                      Plusieurs créneaux disponibles
                    </span>
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                      35 séances / an
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <Link to="/demande-info" className="px-6 py-3 bg-green-500 text-white font-semibold rounded-lg hover:bg-green-600 transition-colors">
                    Demande d'infos
                  </Link>
                </div>
              </div>
            </div>

            {/* Movers */}
            <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-8 rounded-2xl border-l-4 border-blue-500">
              <div className="grid md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 bg-blue-500 text-white text-sm font-semibold rounded-full">A1</span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Cambridge Movers</h3>
                  <p className="text-[#6777A1] mb-4">
                    Renforcement des acquis et développement des compétences de communication. Les enfants apprennent à construire 
                    des phrases plus complexes, à raconter des histoires et à exprimer leurs opinions. Préparation progressive 
                    aux examens Cambridge.
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                      Plusieurs créneaux disponibles
                    </span>
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                      35 séances / an
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <Link to="/demande-info" className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors">
                    Demande d'infos
                  </Link>
                </div>
              </div>
            </div>

            {/* Flyers */}
            <div className="bg-gradient-to-r from-purple-50 to-purple-100 p-8 rounded-2xl border-l-4 border-purple-500">
              <div className="grid md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 bg-purple-500 text-white text-sm font-semibold rounded-full">A2</span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Cambridge Flyers</h3>
                  <p className="text-[#6777A1] mb-4">
                    Niveau le plus élevé des examens Starters/Movers/Flyers. Les élèves développent leur autonomie en anglais : 
                    compréhension de textes, rédaction, discussions sur des sujets variés. Préparation idéale 
                    avant le passage aux examens Key et Preliminary.
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                      Plusieurs créneaux disponibles
                    </span>
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                      35 séances / an
                    </span>
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                      Examen officiel
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <Link to="/demande-info" className="px-6 py-3 bg-purple-500 text-white font-semibold rounded-lg hover:bg-purple-600 transition-colors">
                    Demande d'infos
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#ff3a2d]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Inscrivez votre enfant dès maintenant</h2>
          <p className="text-white/90 mb-8">Demandez une évaluation gratuite pour définir le niveau</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/demande-info" className="px-8 py-4 bg-white text-[#ff3a2d] font-bold rounded-lg hover:bg-gray-100 transition-colors">
              Demande d&apos;informations
            </Link>
            <Link to="/cambridge" className="px-8 py-4 bg-transparent text-white font-bold rounded-lg border-2 border-white hover:bg-white/10 transition-colors">
              Voir les niveaux Cambridge
            </Link>
          </div>
        </div>
      </section>
    </div>
  </Layout>
);

export const ProgrammesAdolescentPage = () => (
  <Layout>
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#285BBB] to-[#2C3C65] py-20 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 text-center relative z-10">
          <span className="inline-block px-4 py-2 bg-white/20 rounded-full text-white text-sm font-medium mb-4">
            Cambridge English for Schools
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Programmes Adolescents</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Collégiens et Lycéens : préparez votre avenir avec les certifications Cambridge reconnues mondialement
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-[#F5F7FF]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-[#2C3C65] mb-6">Un atout pour les études et la vie professionnelle</h2>
              <p className="text-lg text-[#6777A1] mb-6">
                Les certifications Cambridge sont reconnues par plus de 25 000 universités, employeurs et gouvernements dans le monde. 
                Elles constituent un véritable passeport pour les études supérieures et la carrière professionnelle.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="text-3xl font-bold text-[#285BBB]">25 000+</div>
                  <div className="text-sm text-[#6777A1]">Organisations reconnaissent Cambridge</div>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="text-3xl font-bold text-[#285BBB]">À vie</div>
                  <div className="text-sm text-[#6777A1]">Validité des certifications</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_7ad81f0f-836b-4ad1-b763-41e7e6b8cfe2/artifacts/6p8f6v3h_2022-09-25.webp"
                alt="Élèves certifiés"
                className="rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Programmes */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Parcours par niveau</h2>
          
          <div className="space-y-8">
            {/* A2 Key */}
            <div className="bg-gradient-to-r from-orange-50 to-orange-100 p-8 rounded-2xl border-l-4 border-orange-500">
              <div className="grid md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 bg-orange-500 text-white text-sm font-semibold rounded-full">A2</span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Cambridge A2 Key for Schools</h3>
                  <p className="text-[#6777A1] mb-4">
                    Premier niveau de certification Cambridge pour les scolaires. Idéal pour valider un niveau A2 reconnu. 
                    Compétences travaillées : compréhension et expression écrite et orale dans des situations quotidiennes.
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                      Plusieurs créneaux disponibles
                    </span>
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                      35 séances / an
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <Link to="/demande-info" className="px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors">
                    Demande d'infos
                  </Link>
                </div>
              </div>
            </div>

            {/* B1 Preliminary */}
            <div className="bg-gradient-to-r from-teal-50 to-teal-100 p-8 rounded-2xl border-l-4 border-teal-500">
              <div className="grid md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 bg-teal-500 text-white text-sm font-semibold rounded-full">B1</span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Cambridge B1 Preliminary for Schools</h3>
                  <p className="text-[#6777A1] mb-4">
                    Certification intermédiaire parfaite pour les lycéens. Niveau visé par le Baccalauréat. 
                    Permet de démontrer une capacité à utiliser l&apos;anglais dans des situations professionnelles 
                    et académiques simples.
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-teal-500 rounded-full"></span>
                      Plusieurs créneaux disponibles
                    </span>
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-teal-500 rounded-full"></span>
                      Prépa Bac
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <Link to="/demande-info" className="px-6 py-3 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors">
                    Demande d'infos
                  </Link>
                </div>
              </div>
            </div>

            {/* B2 First */}
            <div className="bg-gradient-to-r from-indigo-50 to-indigo-100 p-8 rounded-2xl border-l-4 border-indigo-500">
              <div className="grid md:grid-cols-3 gap-8">
                <div className="md:col-span-2">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 bg-indigo-500 text-white text-sm font-semibold rounded-full">B2</span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Cambridge B2 First for Schools</h3>
                  <p className="text-[#6777A1] mb-4">
                    Le niveau B2 First est le plus demandé pour les études supérieures. Il atteste d&apos;une maîtrise 
                    suffisante de l&apos;anglais pour évoluer dans un environnement anglophone universitaire ou professionnel. 
                    Reconnu par de nombreuses grandes écoles et universités.
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-indigo-500 rounded-full"></span>
                      Plusieurs créneaux disponibles
                    </span>
                    <span className="flex items-center gap-2 text-[#6777A1]">
                      <span className="w-2 h-2 bg-indigo-500 rounded-full"></span>
                      Post-Bac / Grandes Écoles
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <Link to="/demande-info" className="px-6 py-3 bg-indigo-500 text-white font-semibold rounded-lg hover:bg-indigo-600 transition-colors">
                    Demande d'infos
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#285BBB]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Préparez votre avenir dès maintenant</h2>
          <p className="text-blue-100 mb-8">Certifications Cambridge - Un investissement pour la vie</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/demande-info" className="px-8 py-4 bg-white text-[#285BBB] font-bold rounded-lg hover:bg-gray-100 transition-colors">
              Demande d&apos;informations
            </Link>
            <Link to="/cambridge" className="px-8 py-4 bg-transparent text-white font-bold rounded-lg border-2 border-white hover:bg-white/10 transition-colors">
              En savoir plus sur Cambridge
            </Link>
          </div>
        </div>
      </section>
    </div>
  </Layout>
);

export const ProgrammesAdultesPage = () => (
  <Layout>
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#285BBB] to-[#2C3C65] py-20 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 text-center relative z-10">
          <span className="inline-block px-4 py-2 bg-[#ff3a2d] rounded-full text-white text-sm font-medium mb-4">
            100% Éligible CPF
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Nos formations CPF</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            The English Speaking Center évalue votre niveau, étudie votre contexte précis et élabore un programme ciblant vos priorités.
          </p>
        </div>
      </section>

      {/* CPF Banner */}
      <section className="py-8 bg-[#ff3a2d]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <img 
                src="/mon-compte-formation.png"
                alt="Mon Compte Formation"
                className="h-12 bg-white p-1 rounded"
              />
              <div className="text-white">
                <div className="font-bold">Financement CPF</div>
                <div className="text-white/80 text-sm">Formation certifiante à partir du niveau A2</div>
              </div>
            </div>
            <a
              href="https://www.moncompteformation.gouv.fr/espace-prive/html/#/formation/recherche/85185260800013_LEVELTELFACE-TO-FACE/85185260800013_OCTOBER2025?contexteFormation=ACTIVITE_PROFESSIONNELLE"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-white text-[#ff3a2d] font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            >
              Voir sur Mon Compte Formation
            </a>
          </div>
        </div>
      </section>

      {/* Votre CPF */}
      <section className="py-16 bg-[#F5F7FF]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-[#2C3C65] mb-6">Votre CPF</h2>
              <p className="text-[#6777A1] mb-6">
                Vous bénéficiez d&apos;un parcours professionnel solide et maîtrisez votre métier. 
                Vous rassemblez les atouts qui pourraient vous permettre de nouvelles évolutions professionnelles. 
                Néanmoins, votre anglais n&apos;est plus vraiment à la hauteur…
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-xl text-center">
                  <div className="text-3xl font-bold text-green-600">100%</div>
                  <div className="text-xs text-[#6777A1]">Taux de réussite</div>
                </div>
                <div className="bg-white p-4 rounded-xl text-center">
                  <div className="text-3xl font-bold text-green-600">100%</div>
                  <div className="text-xs text-[#6777A1]">Satisfaction stagiaires (4 dernières années)</div>
                </div>
                <div className="bg-white p-4 rounded-xl text-center">
                  <div className="text-3xl font-bold text-[#285BBB]">75</div>
                  <div className="text-xs text-[#6777A1]">Stagiaires formés depuis 2020</div>
                </div>
                <div className="bg-white p-4 rounded-xl text-center">
                  <div className="text-3xl font-bold text-[#285BBB]">99%</div>
                  <div className="text-xs text-[#6777A1]">Formations terminées en 2025</div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_7ad81f0f-836b-4ad1-b763-41e7e6b8cfe2/artifacts/sir01hxa_2021-09-05.webp"
                alt="Formation adultes"
                className="rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Durée et prérequis */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Durée de la formation</h3>
              <p className="text-[#6777A1] mb-4">
                La durée de la formation proposée sera en cohérence avec le niveau de langue visé. 
                Le cadre établi par le certificateur LEVELTEL est le suivant : <strong>un minimum de 10 heures de formation individuelle.</strong>
              </p>
              <a 
                href="https://www.francecompetences.fr/recherche/rs/6265/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#285BBB] hover:underline text-sm"
              >
                Voir sur France Compétences
              </a>
              <div className="mt-6 space-y-3 text-sm text-[#6777A1]">
                <p><strong>La durée dépend de :</strong></p>
                <ul className="space-y-2 ml-4">
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Niveau d&apos;anglais initial du participant
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Objectifs spécifiques de la formation
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Besoins individuels en termes de rythme
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Disponibilité hebdomadaire du participant
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-[#2C3C65] mb-4">Pré-requis</h3>
              <p className="text-[#6777A1]">
                Un positionnement est systématiquement réalisé en amont de la formation &quot;The Initial Test&quot; 
                et le résultat est indiqué lors de l&apos;inscription du candidat.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Méthodes pédagogiques */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Méthodes &amp; Outils pédagogiques</h2>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-[#F5F7FF] p-8 rounded-2xl">
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">Votre formation The English Speaking Center</h3>
              <p className="text-[#6777A1] mb-4">
                Le formateur dispense des cours <strong>exclusivement en anglais</strong> afin de faciliter 
                l&apos;acquisition des automatismes de la langue anglaise. De plus, il alterne apports théoriques, 
                apports pratiques et mises en situation pour que vous gagniez en fluidité et soyez à l&apos;aise en toutes circonstances.
              </p>
              <p className="text-[#6777A1]">
                Votre apprentissage est encadré par des professionnels de la formation, tous de langue maternelle. 
                Nos équipes maîtrisent les pédagogies linguistiques de pointe et détiennent les connaissances pratiques qui pourront vous aider. 
                Nos formateurs sont attentifs, ouverts et à votre écoute.
              </p>
            </div>
            <div className="bg-[#F5F7FF] p-8 rounded-2xl">
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">Supports de formation</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-2xl">📊</span>
                  <div>
                    <p className="font-semibold text-[#2C3C65]">Présentations</p>
                    <p className="text-sm text-[#6777A1]">Supports classiques de type PowerPoint</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">🎬</span>
                  <div>
                    <p className="font-semibold text-[#2C3C65]">Vidéos</p>
                    <p className="text-sm text-[#6777A1]">Diffusées avec projecteur</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">🎮</span>
                  <div>
                    <p className="font-semibold text-[#2C3C65]">Jeux de formation</p>
                    <p className="text-sm text-[#6777A1]">Par exemple Kahoot</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#285BBB] to-[#2C3C65] p-8 rounded-2xl text-white">
            <h3 className="text-xl font-bold mb-4">Rythme de la formation</h3>
            <p className="text-blue-100 mb-4">
              La formation est organisée selon un rythme flexible et personnalisé, défini en fonction des besoins, 
              des objectifs et des disponibilités du stagiaire.
            </p>
            <p className="text-white font-medium mb-3">Plusieurs formats peuvent être proposés :</p>
            <ul className="space-y-2 text-blue-100">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
                1 à 6 séances par semaine
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
                Sessions de 1h à 6h
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
                Cours en journée, en soirée ou le samedi
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
                Parcours régulier, semi-intensif ou intensif
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
                Renforcement ciblé avant certification
              </li>
            </ul>
            <p className="text-blue-100 mt-4 text-sm">
              Ce rythme permet d&apos;assurer une progression efficace tout en s&apos;adaptant aux contraintes professionnelles 
              et personnelles de l&apos;adulte en formation.
            </p>
          </div>
        </div>
      </section>

      {/* Exemple de parcours stagiaire */}
      <section className="py-16 bg-[#F5F7FF]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Exemple de parcours stagiaire</h2>
          
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            {/* Header de l'exemple */}
            <div className="bg-gradient-to-r from-[#285BBB] to-[#2C3C65] p-6 text-white">
              <h3 className="text-xl font-bold mb-2">M. XYZ - Anglais professionnel Logistique &amp; Transport maritime</h3>
              <div className="flex flex-wrap gap-4 text-sm">
                <span className="bg-white/20 px-3 py-1 rounded-full">Certification LEVELTEL</span>
                <span className="bg-white/20 px-3 py-1 rounded-full">Durée : 20 heures</span>
                <span className="bg-white/20 px-3 py-1 rounded-full">Coût : 2 070 €</span>
              </div>
            </div>
            
            <div className="p-6 space-y-6">
              {/* Profil */}
              <div>
                <h4 className="text-lg font-bold text-[#2C3C65] mb-2">1. Profil du stagiaire</h4>
                <p className="text-[#6777A1]">
                  M. XYZ est salarié dans le secteur de la logistique et du transport maritime. 
                  Dans le cadre de son activité professionnelle, il est amené à échanger avec des interlocuteurs internationaux, 
                  à traiter des documents en anglais et à communiquer dans un environnement où la maîtrise de l&apos;anglais professionnel constitue un véritable atout.
                </p>
              </div>
              
              {/* Contexte */}
              <div>
                <h4 className="text-lg font-bold text-[#2C3C65] mb-2">2. Contexte et besoin identifié</h4>
                <p className="text-[#6777A1]">
                  M. XYZ souhaite renforcer ses compétences en anglais afin de mieux répondre aux exigences de son poste. 
                  Il rencontre des difficultés dans certaines situations concrètes : compréhension d&apos;e-mails professionnels, 
                  échanges téléphoniques, vocabulaire spécifique au transport maritime, communication avec des partenaires ou clients étrangers.
                </p>
              </div>
              
              {/* Objectifs */}
              <div>
                <h4 className="text-lg font-bold text-[#2C3C65] mb-2">3. Objectifs de la démarche</h4>
                <ul className="space-y-2 text-[#6777A1]">
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Améliorer sa compréhension orale et écrite en contexte professionnel
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Développer son expression orale dans des situations liées à la logistique et au transport maritime
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Acquérir le vocabulaire technique et professionnel de son secteur
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Gagner en aisance lors des échanges avec des interlocuteurs internationaux
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#285BBB] rounded-full mt-2"></span>
                    Valoriser ses compétences grâce à une certification reconnue
                  </li>
                </ul>
              </div>
              
              {/* Contenu du parcours */}
              <div>
                <h4 className="text-lg font-bold text-[#2C3C65] mb-2">4. Contenu du parcours</h4>
                <p className="text-[#6777A1] mb-3">
                  Le parcours de M. XYZ est construit sur mesure autour de situations concrètes rencontrées dans son environnement professionnel :
                </p>
                <div className="grid md:grid-cols-2 gap-3">
                  {[
                    'Communication professionnelle orale et écrite',
                    'Prise de parole en situation professionnelle',
                    'Compréhension et rédaction d\'e-mails',
                    'Vocabulaire de la logistique et du transport maritime',
                    'Échanges avec clients, fournisseurs, transitaires',
                    'Préparation à la certification LEVELTEL',
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2 bg-[#F5F7FF] p-3 rounded-lg text-sm text-[#6777A1]">
                      <span className="w-2 h-2 bg-[#285BBB] rounded-full"></span>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Organisation */}
              <div>
                <h4 className="text-lg font-bold text-[#2C3C65] mb-2">5. Durée et organisation</h4>
                <p className="text-[#6777A1] mb-3">La formation est prévue sur une durée de <strong>20 heures</strong>.</p>
                <div className="bg-blue-50 p-4 rounded-xl">
                  <p className="text-[#285BBB] font-medium mb-2">Exemple d&apos;organisation possible :</p>
                  <ul className="space-y-1 text-sm text-[#6777A1]">
                    <li>• 10 séances de 2 heures ou sessions de 1h30 à 2h</li>
                    <li>• Cours en journée, en soirée ou le samedi</li>
                    <li>• Possibilité de présentiel, distanciel ou format hybride</li>
                  </ul>
                </div>
              </div>
              
              {/* Financement CPF */}
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200">
                <h4 className="text-lg font-bold text-green-800 mb-3">6. Mobilisation du CPF</h4>
                <div className="grid md:grid-cols-3 gap-4 text-center">
                  <div className="bg-white p-4 rounded-lg">
                    <p className="text-2xl font-bold text-[#2C3C65]">2 070 €</p>
                    <p className="text-xs text-gray-500">Coût total de la formation</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg">
                    <p className="text-2xl font-bold text-green-600">1 500 €</p>
                    <p className="text-xs text-gray-500">Montant CPF mobilisé (exemple)</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg">
                    <p className="text-2xl font-bold text-amber-600">570 €</p>
                    <p className="text-xs text-gray-500">Reste à charge éventuel</p>
                  </div>
                </div>
                <p className="text-sm text-green-700 mt-4">
                  Lorsque le montant disponible sur le compte CPF ne couvre pas l&apos;intégralité du coût de la formation, 
                  le reste à charge peut être réglé directement par le stagiaire, pris en charge par l&apos;employeur ou 
                  faire l&apos;objet d&apos;un abondement complémentaire.
                </p>
              </div>
              
              {/* Résultat attendu */}
              <div>
                <h4 className="text-lg font-bold text-[#2C3C65] mb-2">7. Résultat attendu</h4>
                <p className="text-[#6777A1] mb-3">À l&apos;issue de son parcours, M. XYZ sera en mesure de :</p>
                <ul className="space-y-2 text-[#6777A1]">
                  <li className="flex items-start gap-2">
                    <span className="text-green-500">✓</span>
                    Communiquer avec plus d&apos;aisance dans son environnement professionnel
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-500">✓</span>
                    Mieux comprendre les échanges liés à la logistique et au transport maritime
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-500">✓</span>
                    Utiliser un vocabulaire plus précis et plus adapté à son secteur
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-500">✓</span>
                    Gagner en efficacité dans ses relations avec des interlocuteurs internationaux
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-green-500">✓</span>
                    Attester de son niveau grâce au passage de la certification LEVELTEL
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comment s'inscrire */}
      <section className="py-16 bg-[#F5F7FF]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Comment s&apos;inscrire ?</h2>
          
          <div className="max-w-3xl mx-auto">
            <p className="text-[#6777A1] mb-8 text-center">
              Vous souhaitez apprendre l&apos;anglais de manière réellement personnalisée ? Contactez-nous et découvrez 
              les solutions que nous proposons pour répondre à votre situation précise.
            </p>
            
            <div className="space-y-4">
              {[
                { step: '1', title: 'Premier contact', desc: 'Passez-nous un simple coup de fil, posez-nous vos questions par email ou utilisez notre formulaire de contact.' },
                { step: '2', title: 'Rendez-vous', desc: 'Nous fixons un rendez-vous dans nos locaux ou par visioconférence ou téléphone selon vos possibilités.' },
                { step: '3', title: 'Évaluation du niveau', desc: 'À l\'aide d\'un QCM - THE INITIAL TEST suivi d\'un entretien oral (reading, writing, listening and speaking) en tête à tête avec notre responsable pédagogique.' },
                { step: '4', title: 'Votre dossier en ligne', desc: 'Votre CPF peut prendre en charge jusqu\'à 100% du coût de vos cours d\'anglais. Quelques clics suffisent pour financer votre formation !' },
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-4 p-4 bg-white rounded-xl">
                  <div className="w-10 h-10 bg-[#285BBB] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">{item.step}</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#2C3C65]">{item.title}</h4>
                    <p className="text-sm text-[#6777A1]">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Délai d'accès */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white border border-gray-200 p-8 rounded-2xl">
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">Délai d&apos;accès</h3>
              <p className="text-[#6777A1] mb-4">
                Grâce au Compte Personnel de Formation (CPF), vous pouvez vous former tout au long de votre vie professionnelle. 
                Votre formation débutera à la date de votre choix selon les conditions suivantes :
              </p>
              <div className="bg-[#F5F7FF] p-4 rounded-xl">
                <p className="text-sm text-[#6777A1]">
                  <strong>Formation CPF :</strong> vous aurez un délai de réflexion obligatoire d&apos;onze jours ouvrés 
                  entre la validation de votre demande de formation sur le site www.moncompteformation.gouv.fr et le début de votre stage. 
                  La mise en place la plus rapide sera d&apos;environ <strong>14 jours ouvrés</strong> après votre inscription à l&apos;offre.
                </p>
              </div>
            </div>
            <div className="bg-white border border-gray-200 p-8 rounded-2xl">
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">Démarrage de la formation</h3>
              <p className="text-[#6777A1]">
                La formation débute à la signature du contrat et convocation précisant les dates, la durée, 
                la fréquence, l&apos;équipe pédagogique et le coût.
              </p>
              <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-xl">
                <p className="text-sm text-amber-800">
                  <strong>Participation financière obligatoire :</strong> Depuis mai 2024, tous les titulaires qui mobilisent leurs droits CPF 
                  doivent verser une participation financière obligatoire, à régler avant de valider l&apos;inscription.
                </p>
                <a 
                  href="https://www.moncompteformation.gouv.fr/espace-public/une-participation-financiere-obligatoire-pour-mobiliser-vos-droits-cpf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-amber-700 hover:underline text-xs mt-2 inline-block"
                >
                  En savoir plus
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Méthode de contrôle */}
      <section className="py-16 bg-[#F5F7FF]">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Méthode de contrôle</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                <span className="text-2xl">📝</span>
              </div>
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">1. Évaluation des acquis au cours de la formation</h3>
              <p className="text-[#2C3C65] font-semibold mb-2">A MID ENGLISH TEST</p>
              <p className="text-[#6777A1]">
                Un contrôle de la progression est effectué régulièrement tout au long de la formation 
                à l&apos;aide de tests écrits ou oraux permettant de réajuster le programme si nécessaire.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl">
              <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-4">
                <span className="text-2xl">🎓</span>
              </div>
              <h3 className="text-xl font-bold text-[#2C3C65] mb-4">2. Évaluation du niveau en fin de formation</h3>
              <p className="text-[#2C3C65] font-semibold mb-2">A FINAL ENGLISH TEST</p>
              <p className="text-[#6777A1]">
                Un test de fin de formation est effectué par le formateur avec les compétences et le niveau acquis (niveau CECRL).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-10 text-center">Certification officielle</h2>
          
          <p className="text-center text-[#6777A1] mb-8">
            Possibilité de préparer et certifier votre niveau en langue avec les tests officiels :
          </p>

          <div className="grid md:grid-cols-2 gap-6">
            <a 
              href="https://leveltel.com/l/FR/levetel-certifiant"
              target="_blank"
              rel="noopener noreferrer"
              className="p-6 bg-white rounded-xl border border-gray-200 flex items-center gap-6 hover:shadow-lg transition-shadow"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_8ac9ff11-8439-4edd-b71a-13f35871b045/artifacts/5sovhi7v_LEVELTEL_LOGO.jpg"
                alt="LEVELTEL"
                className="h-16"
              />
              <div>
                <h4 className="font-bold text-[#2C3C65]">LEVELTEL CERTIFIANT</h4>
                <p className="text-sm text-[#6777A1]">Certification délivrée à partir du niveau A2</p>
              </div>
            </a>
            <a 
              href="https://www.cambridgeenglish.org/fr/exams-and-tests/certification-anglais-linguaskill/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-6 bg-white rounded-xl border border-gray-200 flex items-center gap-6 hover:shadow-lg transition-shadow"
            >
              <div className="h-16 flex items-center">
                <div className="text-center">
                  <div className="text-[#285BBB] font-bold">Cambridge</div>
                  <div className="text-[#2C3C65] text-sm font-medium">Linguaskill</div>
                </div>
              </div>
              <div>
                <h4 className="font-bold text-[#2C3C65]">Cambridge Linguaskill</h4>
                <p className="text-sm text-[#6777A1]">Test adaptatif en ligne. Résultats en 48h.</p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Tarifs */}
      <section className="py-16 bg-[#F5F7FF]">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-[#2C3C65] mb-6">Tarifs</h2>
          <p className="text-[#6777A1] mb-8">
            Veuillez nous consulter pour un devis personnalisé ou découvrez nos offres éligibles au financement CPF.
          </p>
          <a
            href="https://www.moncompteformation.gouv.fr/espace-prive/html/#/formation/recherche/85185260800013_LEVELTELFACE-TO-FACE/85185260800013_OCTOBER2025?contexteFormation=ACTIVITE_PROFESSIONNELLE"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-[#285BBB] text-white font-bold rounded-lg hover:bg-[#1e4a9a] transition-colors"
          >
            Voir nos offres sur Mon Compte Formation
          </a>
        </div>
      </section>

      {/* Attention aux arnaques */}
      <section className="py-8 bg-red-50 border-y border-red-200">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-start gap-4">
            <span className="text-3xl">⚠️</span>
            <div>
              <h3 className="font-bold text-red-800 mb-2">Attention aux arnaques !</h3>
              <p className="text-red-700 text-sm">
                Soyez prudent, de nombreuses tentatives d&apos;escroquerie ont lieu pour tenter de dérober vos crédits CPF. 
                Vous pouvez être contactés par sms ou emails au nom du CPF en vous proposant de vous inscrire à des fausses formations 
                afin de récupérer votre budget CPF. Cela peut aller jusqu&apos;à 5000€ selon les profils. 
                <strong> Ne transmettez jamais vos données personnelles à quiconque.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#2C3C65]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Prêt à booster votre anglais ?</h2>
          <p className="text-blue-100 mb-8">Demandez votre évaluation gratuite et personnalisée</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/demande-info" className="px-8 py-4 bg-[#ff3a2d] text-white font-bold rounded-lg hover:bg-[#e6352a] transition-colors">
              Demande d&apos;informations
            </Link>
            <a 
              href="https://www.moncompteformation.gouv.fr/espace-prive/html/#/formation/recherche/85185260800013_LEVELTELFACE-TO-FACE/85185260800013_OCTOBER2025?contexteFormation=ACTIVITE_PROFESSIONNELLE"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-transparent text-white font-bold rounded-lg border-2 border-white hover:bg-white/10 transition-colors"
            >
              Voir sur Mon Compte Formation
            </a>
          </div>
        </div>
      </section>

      {/* Accessibilité */}
      <section className="py-8 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-sm text-[#6777A1]">
            <strong>Accès personnes handicapées :</strong> Veuillez nous contacter au 06 26 71 60 22 
            pour être mis en relation avec notre référent handicap pour discuter des solutions d&apos;accessibilité 
            pour les personnes en situations d&apos;handicap.
          </p>
        </div>
      </section>
    </div>
  </Layout>
);